import {css, Theme} from "@emotion/react";
import {borderRadius, h100, m, onDesktop, p, pb, w100} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";

import quoteBg from "../../assets/quotemark.svg";

const textVerticalSpace = css`
    margin: 0;
    ${m(2, 0, 2, 0)};

    ${onDesktop(m(3, 0, 3, 0))}
`;

export const contentWrapper = (theme: Theme) => css`
    ${getTextVariantStyleFor("body_copy_0")(theme)};
    ${pb(3)};

    a {
        text-decoration: underline;

        &:hover {
            color: ${theme.colors.highlight};
        }
    }

    h2,
    h3,
    h4 {
        ${textVerticalSpace};
    }

    h2 {
        ${getTextVariantStyleFor("headline_2")(theme)};
    }

    h3 {
        ${getTextVariantStyleFor("headline_3")(theme)};
    }

    h4 {
        ${getTextVariantStyleFor("headline_4")(theme)};
    }

    p,
    span {
        ${textVerticalSpace};
    }

    img {
        max-inline-size: 100%;
        block-size: auto;
    }

    ul {
        ${getTextVariantStyleFor("body_copy_0")(theme)};
        ${m(0, 0, 2, 3)}

        ${onDesktop(m(0, 0, 4, 3))}
    }

    li {
        list-style-type: disc;
    }

    blockquote {
        position: relative;
        border: none;
        background-size: 6.4rem;
        background-position: 8px;
        background-color: #fff;
        ${borderRadius(2)};
        ${p(2, 2, 2, 7)};
        ${m(0)};

        line-height: 2rem;

        ${onDesktop(
            p(2, 2, 2, 11),
            m(0),
            css`
                line-height: 2.4rem;
            `
        )}
        &:before {
            content: "";
            position: absolute;
            background-image: url(${quoteBg});
            background-position: center;
            background-size: contain;
            top: 8px;
            left: 8px;
            height: 3.2rem;
            width: 3.2rem;
            z-index: 2;

            ${onDesktop(css`
                height: 6.4rem;
                width: 6.4rem;
            `)};
        }
    }

    iframe {
        ${w100};
        ${h100};
        aspect-ratio: 16/9;
    }
`;

export const blockquoteContent = (theme: Theme) => css`
    font-style: italic;
    color: ${theme.colors.gray[800]};
`;
